type Validation = {
  type:
    | 'name'
    | 'birthDay'
    | 'nickName'
    | 'backAccount'
    | 'backOwner'
    | 'phoneNumber'
    | 'walletAddress'
    | 'walletName'
    | 'address'
    | 'zipcode'
    | 'addressDetail'
  data: string | number
}

/**
 * validation check를 위한 함수
 * @param validation.type 정규식 타입
 * @param validation.data 검증할 데이터
 * @returns boolean
 */
export const validateInput = (validation: Validation): boolean => {
  const validData = String(validation.data)

  const pnCheck = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/gim // 핸드폰 번호 체크
  const birthdayCheck = /^[\d]{8}$/gim // 생년월일 체크
  const specialCharCheck = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gim // 특수문자 제외
  const specialCharKoCheck = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ㄱ-ㅎㅏ-ㅣ가-힣]/gim // 특수문자, 한글 제외
  const specialCharNumCheck = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ 0-9]/gim // 특수문자, 숫자 제외
  const walletAddressCheck = /^(0x)?[0-9a-fA-F]{40}$/gim

  switch (validation.type) {
    case 'name':
      return specialCharNumCheck.test(validData)
    case 'birthDay':
      if (validData.length === 0) {
        return false
      }
      return !birthdayCheck.test(validData)
    case 'nickName':
      return specialCharCheck.test(validData)
    case 'backAccount':
      return specialCharKoCheck.test(validData)
    case 'backOwner':
      return specialCharNumCheck.test(validData)
    case 'phoneNumber':
      if (validData.length === 0) {
        return false
      }
      return !pnCheck.test(validData)
    case 'walletAddress':
      if (validData.length === 0) {
        return false
      }
      return !walletAddressCheck.test(validData)
    case 'walletName':
      return specialCharCheck.test(validData)
    case 'zipcode':
      return specialCharCheck.test(validData)
    case 'address':
      return specialCharCheck.test(validData)
    case 'addressDetail':
      return specialCharCheck.test(validData)
    default:
      return false
  }
}
